var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('date-picker',{attrs:{"format":_vm.format,"placeholder":"dd-mm-jjjj","type":_vm.type,"prefix-class":"xmx-large","clearable":_vm.clearable},model:{value:(_vm.Model),callback:function ($$v) {_vm.Model=$$v},expression:"Model"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }